import React from 'react'

export default function ReportsPage() {
  return (
    <div>ReportsPage</div>
  )
}
